// extracted by mini-css-extract-plugin
export var numberInputContainer = "_62-0";
export var startPickingButton = "_62-1";